import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import Cookies from 'universal-cookie'
import { toast } from 'react-toastify'
import Input from '@mawesi-sas/mws_react_component_input'

import {
    signIn
} from './actions'

import { clearMessage } from '../Layout/actions'

import '../../css/signin.css'

import bg from '../../img/bg-1.jpg'
import logo from '../../img/logo-icesi.png'

const cookies = new Cookies()

class SignIn extends Component {
    componentWillMount() {
        this.props.clearMessage()
        const token = cookies.get('token')
        if (token) {
            this.props.history.push(window.FOLDER + '/')
        }
    }

    componentDidUpdate() {
        this.props.clearMessage()
    }

	render() {
        const { processing } = this.props
        if (this.props.message) {
            const { message } = this.props
            switch (message.get('type')) {
                case 'danger':
                    toast.error(message.get('message'))
                    break
                case 'warning':
                    toast.warn(message.get('message'))
                    break
                case 'success':
                    toast.success(message.get('message'))
                    break
                default:
                    toast.info(message.get('message'))
            }
        }

		return (
            <div className="signin-container" style={{ backgroundImage: `url(${bg})` }}>
                <div className="login-box animated fadeIn">
                    <div>
                        <div>
                            <img src={ logo } style={{ verticalAlign: 'middle' }} alt="logo" />
                        </div>
                    </div>
                    <div>
                        <p className="text-center" style={{ fontSize: '24px', fontWeight: 300, margin: '15px 0' }}>Inicio de sesión</p>
                        <form onSubmit={ e => { e.preventDefault(); this.props.signIn({ username: this.props.username, password: this.props.password }) }}>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <Input
                                            reducer='signin'
                                            path='username'
                                            type="text"
                                            placeholder="Nombre de usuario"
                                    />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12" style={{"margin": '10px 0'}}>
                                        <Input
                                            reducer='signin'
                                            path='password'
                                            type="password"
                                            placeholder="Contraseña"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <button className="btn btn-default btn-sm" style={{ width: '100%', padding: '5px 30px' }} disabled={ processing }>{ processing ? <span><FontAwesome name="circle-o-notch" spin/> Iniciando sesión ...</span> : <span>Inciar sesión</span> }</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        username: state.signin.get('username'),
        password: state.signin.get('password'),
        processing: state.signin.get('processing'),
        message: state.layout.get('message')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        signIn: (credentials) => dispatch(signIn(credentials)),
        clearMessage: () => dispatch(clearMessage())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)